export const convertCamelCaseToBasicString = (camelCaseString: string) => {
  const words = camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2').split(/[\s_]+/);
  const normalCase = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

  return normalCase;
};

export const toNormalCase = (value: string) => {
  const capitalized = value[0].toUpperCase();

  if (value.length === 1) {
    return capitalized;
  }

  return capitalized + value.slice(1);
};

export const convertToDataIdAttr = (s: string) => {
  const symbolsToRemove = /[(){}!@#$%^&*\-+_=/.,;:'"`]/g;

  return s.split(' ').map(toNormalCase).join('').replace(symbolsToRemove, '');
};

export const convertToSlug = (text: string) => {
  return text
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\\-]+/g, '')
    .replace(/\\-\\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};
